import { Environment } from '@sg/common';

/**
 * Returns the deploy URL, which is a prefix added to the URL that is not part of the app's routing.
 */
export function getDeployUrl(suffixIfNotEmpty: string = ''): string {
  const script = Array.from(document.getElementsByTagName('script')).find(s => !s.src?.includes('hotjar'));
  const segments = script.src.split('/');
  segments.pop();
  return segments.join('/') + suffixIfNotEmpty;
}

export function brandingStyleLoader(css: string | string[], production: boolean, pathPrefix: string): void {
  const files = Array.isArray(css) ? css : [css];

  for (const cssFile of files) {
    let element: HTMLElement;
    const link: HTMLLinkElement = element = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.type = 'text/css';
    link.href = `${pathPrefix}${cssFile}.css`;
    document.head.appendChild(element);
  }
}

const EXTERNAL_PROVIDER_DETECT_REGEXP = new RegExp(`^.*\\b/sso/init/(?<externalProvider>[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}|\\baad\\b|\\bsgwp\\b)\\b.*$`);
export function detectExternalProvider() {
  const match = EXTERNAL_PROVIDER_DETECT_REGEXP.exec(location.href);
  return match?.groups?.externalProvider;
}

/**
 * Normalize the redirects on the OIDC object to match the current location.origin
 */
export function oidcUriNormalizer(oidc: Environment['oidc']) {
  oidc.redirect_uri = `${location.origin}/oidc-signin`;
  oidc.post_logout_redirect_uri = `${location.origin}/oidc-signout`;
  oidc.silent_redirect_uri = `${location.origin}/oidc-renew`;
}

const SUBDOMAIN_REGEXP = /^(.+)\.sharegain\.com$/;
const INVALID_BRAND_SUBDOMAINS = ['api', 'api-dev', 'api-test'];
const HOSTNAME_DETECT_REGEXP = new RegExp(`^(?:borrower|lender|admin|onboarding|specials|analyzer|lead)(?:-dev|-test)?\\.sharegain\\.com$`);
export function getBrandingFromUrl(): { name: string; type: 'subDomain' | 'query' } {
  const hostName = location.hostname;
  const subdomain = hostName.match(SUBDOMAIN_REGEXP)?.[1];
  if (!!subdomain && !INVALID_BRAND_SUBDOMAINS.includes(subdomain) && !HOSTNAME_DETECT_REGEXP.test(hostName)) {
    return { name: subdomain, type: 'subDomain' };
  }
  const brandName = getParameterByName('brand');
  if (!!brandName) {
    return { name: brandName, type: 'query' };
  }
}

function getParameterByName(name: string, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
